<template>
    <div class="py-4">
        <navs v-if="!activeChat">
            <li v-for="route in $router.options.routes" :key="route.path" class="nav-item">
                <router-link class="nav-link" :to="route.path">
                    {{ route.label }}
                </router-link>
            </li>
        </navs>
        <transition name="fade-in">
            <router-view/>
        </transition>
    </div>
</template>

<script>
    import VueRouter    from 'vue-router';
    import ChatContact  from './ChatContact';
    import TemplateList from './TemplateListChat';

    const router = new VueRouter({
        routes              : [
            {
                path     : '/',
                label    : 'Chat',
                component: ChatContact,
            },
            {
                path     : '/template',
                label    : 'Templates',
                component: TemplateList,
            },
        ],
        linkExactActiveClass: 'active',
    });

    export default {
        router,

        computed: {
            activeChat() {
                return this.$store.state.isActiveChatMessenger;
            }
        }
    };
</script>
